export default "__VITE_ASSET__b85kKBHi__"